import classNames from 'classnames';

interface IconProps {
    className?: string | null;
}

function Binoculaires({ className = null }: IconProps) {
    return (
        <svg
            className={classNames([{ [className]: className !== null }])}
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 353.74 133.41"
        >
            <defs>
                <filter
                    id="drop-shadow-binoculaires-1"
                    x="0"
                    y="0"
                    width="127.48"
                    height="84.94"
                    filterUnits="userSpaceOnUse"
                >
                    <feOffset dx="5" dy="5" />
                    <feGaussianBlur result="blur" stdDeviation="0" />
                    <feFlood floodColor="#000" floodOpacity="1" />
                    <feComposite in2="blur" operator="in" />
                    <feComposite in="SourceGraphic" />
                </filter>
                <filter
                    id="drop-shadow-binoculaires-2"
                    x="226.26"
                    y="48.48"
                    width="127.48"
                    height="84.94"
                    filterUnits="userSpaceOnUse"
                >
                    <feOffset dx="5" dy="5" />
                    <feGaussianBlur result="blur-2" stdDeviation="0" />
                    <feFlood floodColor="#000" floodOpacity="1" />
                    <feComposite in2="blur-2" operator="in" />
                    <feComposite in="SourceGraphic" />
                </filter>
            </defs>
            <path
                d="M24.84,58.66L2.55,35.02l32.35,3.06-1.88-32.44,22.81,23.14L75.23,2.73l2.6,32.39,31.62-7.48-18.82,26.48,29.03,14.59-31.44,8.19c-25.41,5.82-46.3-.89-63.38-18.23Z"
                fill="#f63"
                filter="url(#drop-shadow-binoculaires-1)"
                stroke="#000"
                strokeMiterlimit="10"
                strokeWidth="2"
            />
            <path
                d="M251.1,107.13l-22.29-23.64,32.35,3.06-1.88-32.44,22.81,23.14,19.41-26.06,2.6,32.39,31.62-7.48-18.82,26.48,29.03,14.59-31.44,8.19c-25.41,5.82-46.3-.89-63.38-18.23Z"
                fill="#f63"
                filter="url(#drop-shadow-binoculaires-2)"
                stroke="#000"
                strokeMiterlimit="10"
                strokeWidth="2"
            />
        </svg>
    );
}

export default Binoculaires;
